<div id="popup">
  @if (stillGoing) {
    <p>Loading...</p>
  }
  @if (errormessage) {
    <p id="error-message">
      {{errormessage}}
    </p>
  }

  <mat-dialog-actions align="right">
    @if (!stillGoing) {
      <button id="cancel-button" class="mat-raised-button action-button" (click)="close()">CLOSE</button>
    }
  </mat-dialog-actions>
</div>
